import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="rents--document"
// Handles file uploads in the sidebar and syncs them to the hidden
// file input inside the main form so files are included on submit.
export default class extends Controller {
  handleContractUpload(event) {
    this.syncFile(event, "main-contract-input")
  }

  syncFile(event, targetId) {
    const file = event.target.files[0]
    if (!file) return

    const mainInput = document.getElementById(targetId)
    if (mainInput) {
      const dataTransfer = new DataTransfer()
      dataTransfer.items.add(file)
      mainInput.files = dataTransfer.files
      mainInput.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }
}
